import React from 'react'
import { connect } from 'react-redux'
// import { bindActionCreators } from 'redux'
import { withStyles, Avatar } from '@material-ui/core'
import { Person } from '@material-ui/icons'
import classNames from 'classnames'

const styles = (theme) => ({
  avatar: {
    // position: 'absolute',
    // top: 17,
    // left: 10,
    color: '#fff',
  },
  avatarContact: {
    borderRadius: 8,
    backgroundColor: require('components/withRoot').themeObj.palette.green,
  },
  avatarUser: {
    borderRadius: '50%',
    backgroundColor: theme.palette.secondary.main,
  },
})

const AvatarWithLabel = ({ classes, type, businessName, label, noType }) => {
  let avatarOrInitials = <Person />

  if (label) {
    const initials = label
      .split(' ')
      .map((word) => word.slice(0, 1))
      .join('')
      .slice(0, 3)

    if (
      label !== 'System' &&
      (initials.length > 1 || initials.match(/[a-z]/i))
    ) {
      avatarOrInitials = initials
    }
  }

  return (
    <div style={{ textAlign: 'center', width: 40 }}>
      <Avatar
        className={classNames(
          classes.avatar,
          type === 'user' ? classes.avatarUser : classes.avatarContact,
        )}
      >
        {avatarOrInitials}
      </Avatar>
      {!noType && (
        <div
          style={{
            fontSize: 10,
            fontWeight: 'bold',
            color: type === 'user' ? '#014c94' : '#14b940',
          }}
        >
          {type === 'user' ? 'User' : 'Contact'}
        </div>
      )}
    </div>
  )
}

export default connect(
  (state) => ({
    businessName:
      state.AccountSettings.settings &&
      state.AccountSettings.settings.business_name,
  }),
  null,
)(withStyles(styles)(AvatarWithLabel))
